import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from '@wordpress/api-fetch';
import { SUBSCRIPTIONS } from './constants';

export const fetchSubscriptions = createAsyncThunk(SUBSCRIPTIONS.FETCH_SUBSCRIPTIONS, async () => {
    const response = await apiFetch({
        method: 'GET',
        path: '/subscriptions',
    });
    return response.data;
});

export const fetchSubscription = createAsyncThunk(SUBSCRIPTIONS.FETCH_SUBSCRIPTION, async (id) => {
    const response = await apiFetch({
        method: 'GET',
        path: `/subscriptions/${id}`,
    });
    return response.data;
});

export const fetchSubscriptionFromOrder = createAsyncThunk(SUBSCRIPTIONS.FETCH_SUBSCRIPTION_FROM_ORDER, async (orderId) => {
    const response = await apiFetch({
        method: 'GET',
        path: `/subscriptions/order/${orderId}`,
    });
    return response.data;
});
